import { useSelector } from "react-redux";
import Question from "../Question";

const TestContainer = (props) => {
    const { onAnswer } = props;
    const question = useSelector(state => state.game.questions[state.game.currentIndex]);
    
    return (
        <Question question={question} onAnswer={onAnswer} />
    )
}

export default TestContainer;